import React, {useEffect, useState} from 'react';
import {loadOrderAsync} from "../../../../app/store/reducers/order/orderReducer";
import AddShipmentForm from "../../../../components/hippo/shipment/AddShipmentForm";
import EventBus from "../../../../app/eventbus/EventBus";
import {REGISTER_SHIPMENT_SUCCEED} from "../../../../app/eventbus/shipmentEvents";
import {useHistory, useRouteMatch} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {saveContractId} from "../../../../app/store/reducers/contract/contractReducer";
import {shipmentSaveProviders} from "../../../../app/store/reducers/shipment/shipmentReducer";
import {
    getOrganizationInfoAsync,
    loadCompanyProductCatalogsAsync,
    selectCompanyCatalogs
} from "../../../../app/store/reducers/roaming/roamingReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import {PermissionEdiShipmentCreate} from "../../../../enum/Permission/EdiPermission";
import {selectAccountRolePermissions} from "../../../../app/store/reducers/role/roleReducer";
import {selectActiveOrganization} from "../../../../app/store/reducers/auth/authReducer";
import {
    ITEM_INITIALIZATION_STATE_COMPLETE,
    selectItemInitializationState
} from "../../../../app/store/reducers/item/itemReducer";
import SpinnerComponent from "../../../../components/hippo/spinner/SpinnerComponent";
import {
    loadCatalogsByCode
} from "../../../../app/store/reducers/roamingReference/roamingReferenceReducer";
import {uniq} from "underscore";

const AddShipment = () => {
    const catalogs = useSelector(selectCompanyCatalogs);
    const [order, setOrder] = useState(null)
    const [organizationInfo, setOrganizationInfo] = useState(null)
    const {params: {id}} = useRouteMatch();
    const routerHistory = useHistory();
    const dispatch = useDispatch();
    const history = useHistory()
    const permission = useSelector(selectAccountRolePermissions)
    const activeOrganization = useSelector(selectActiveOrganization)
    const itemInitializationState = useSelector(selectItemInitializationState)

    useEffect(() => {
        if (permission.length && !dispatch(checkPermission(PermissionEdiShipmentCreate))) {
            if (history.length > 1) {
                history.push('/edi/orders')
            } else {
                history.push('/')
            }
        }
    }, [permission])

    useEffect(() => {
        getOrganizationInfoAsync(activeOrganization.inn || activeOrganization.pinfl)
            .then((res) => setOrganizationInfo(res))
            .catch((e) => setOrganizationInfo(e))
    }, [activeOrganization])


    const loadOrder = async () => {
        try {
            const order = await loadOrderAsync(id);
            const unknownCatalogCodes = uniq(order?.items?.map((item) => item?.catalog_class_code));
            const catalogs = await loadCatalogsByCode({codes: unknownCatalogCodes});
            setOrder({...order, items: order.items.map((item, index) => {
                const catalog = catalogs.find((catalog) => catalog.class_code === item?.catalog_class_code);
                return {
                    uid: index,
                    id: item.id,
                    product: item.product,
                    barcode: item.barcode,
                    customer_shipment_id: item.customer_shipment_id,
                    executor_item: item.executor_item,
                    measurement: item.measurement,
                    quantity: item.quantity_left,
                    price: item.price,
                    total: item.total,
                    nds_rate: item.nds_rate,
                    nds_value: item.nds_value,
                    quantity_left: item.quantity_left,
                    total_with_nds: item.total_with_nds,
                    catalog_class_name: catalog?.class_name || item.catalog_class_name || null,
                    catalog_class_code: catalog?.class_code || item.catalog_class_code || null,
                    package_code: null,
                    package_name: null,
                    benefit: item.benefit,
                    mark: {
                        productType: null,
                        kiz: [
                            {code: ''}
                        ],
                        nomUpak: [
                            {code: ''}
                        ],
                        identTransUpak: [
                            {code: ''}
                        ],
                    },
                }
            })})
            dispatch(loadCompanyProductCatalogsAsync(order.executor.inn));
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        loadOrder().then();
    }, [id])


    useEffect(() => {
        const onShipmentAddedListener = EventBus.on(REGISTER_SHIPMENT_SUCCEED, shipment => {
            dispatch(saveContractId())
            dispatch(shipmentSaveProviders())
            routerHistory.push(`/edi/shipment/${shipment.id}`);
        });

        return () => {
            EventBus.remove(REGISTER_SHIPMENT_SUCCEED, onShipmentAddedListener)
        }
    }, []);

    if (itemInitializationState !== ITEM_INITIALIZATION_STATE_COMPLETE)
        return <SpinnerComponent />

    return (
        <>
            {(order && catalogs.length > 0 && organizationInfo) && <AddShipmentForm order={order} organizationInfo={organizationInfo}/>}
            {(!order && !organizationInfo) && <span>loading....</span>}
        </>
    );
};

export default AddShipment;
